import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';
import classNames from 'classnames';

export default class Button extends Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        onClick: PropTypes.func,
    };

    render() {
        const {label, disabled, className, onClick} = this.props;

        const buttonClassName = classNames(className, styles.button);

        return (
            <button
                tabIndex={-1}
                className={buttonClassName}
                disabled={disabled}
                onClick={onClick}
            >
                <div>{label}</div>
            </button>
        );
    }
}
